import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-component',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.css']
})
export class BlankComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
